import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EmergencyComponent} from './emergency.component';

const routes: Routes = [
    {
        path: 'emergency', component: EmergencyComponent,
        children: [
            {path: 'emg-patient-list', loadChildren: 'app/emergency/emg-patient-list/emg-patient-list.module#EmgPatientListModule'},
            {path: 'emg-patient-discharge-list', loadChildren: 'app/emergency/emg-patient-discharge-list/emg-patient-discharge-list.module#EmgPatientDischargeListModule'},
            {path: 'emg-patient-cancel-list', loadChildren: 'app/emergency/emg-patient-cancel-list/emg-patient-cancel-list.module#EmgPatientCancelListModule'},
            {path: 'emg-triage-form', loadChildren: 'app/emergency/emg-triage-form/emg-triage-form.module#EmgTriageFormModule'},
            {path: 'emg-triage-form/:erId/:mrId/:visitId', loadChildren: 'app/emergency/emg-triage-form/emg-triage-form.module#EmgTriageFormModule'},
            {path: 'emg-nursing-assessment-form', loadChildren: 'app/emergency/emg-nursing-assessment-form/emg-nursing-assessment-form.module#EmgNursingAssessmentFormModule'},
            {path: 'emg-nursing-assessment-form/:erId/:mrId/:visitId', loadChildren: 'app/emergency/emg-nursing-assessment-form/emg-nursing-assessment-form.module#EmgNursingAssessmentFormModule'},
            {path: 'emg-consent-form', loadChildren: 'app/emergency/emg-consent-form/emg-consent-form.module#EmgConsentFormModule'},
            {path: 'emg-consent-form/:erId/:mrId/:visitId', loadChildren: 'app/emergency/emg-consent-form/emg-consent-form.module#EmgConsentFormModule'},
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emergency/emergency.routing.ts